// Real per-product "sold" numbers, fetched once per page load from a
// static JSON snapshot baked into the theme (assets/social-proof-data.json,
// regenerated from real order history on an ad-hoc/monthly cadence --
// these numbers don't need to be live) and applied to whichever elements
// are on the page: the product-page line (data-stp-pdp-handle, shows
// sold_7d with a pulsing dot) and collection-card lines
// (data-stp-card-handle, shows total_sold). Guarded so re-including this
// script (once per card on a collection grid) only fetches and applies
// once. The snapshot's URL is set by the snippet that includes this
// script (window.STP_SOCIAL_PROOF_URL), since a plain asset file like
// this one can't resolve Shopify's asset_url itself.
(function () {
  if (window.__stpSocialProofLoaded) return;
  window.__stpSocialProofLoaded = true;

  var url = window.STP_SOCIAL_PROOF_URL;
  if (!url) return;

  function applyPdp(data) {
    document.querySelectorAll("[data-stp-pdp-handle]").forEach(function (el) {
      var stats = data[el.getAttribute("data-stp-pdp-handle")];
      if (!stats || !stats.sold_7d) return;
      el.textContent = stats.sold_7d + " sold in the last 7 days";
      el.hidden = false;
    });
  }

  function applyCards(data) {
    document.querySelectorAll("[data-stp-card-handle]").forEach(function (el) {
      var stats = data[el.getAttribute("data-stp-card-handle")];
      if (!stats || !stats.total_sold) return;
      el.textContent = stats.total_sold.toLocaleString("en-IN") + "+ sold";
      el.hidden = false;
    });
  }

  fetch(url)
    .then(function (res) {
      return res.ok ? res.json() : null;
    })
    .then(function (data) {
      if (!data) return;
      applyPdp(data);
      applyCards(data);
    })
    .catch(function () {
      // Missing/broken snapshot file -- leave the hidden placeholders
      // hidden rather than show a stale or fabricated number.
    });
})();
